<app-auto-page-heading [isCarrier]="!isGlobalUser"
                       [(selectedRegion)]="selectedRegion"
                       [(selectedCarrier)]="selectedCarrier"
                       (selectedCarrierChange)="updateSelectedCarrier($event)"
                       (selectedRegionChange)="updateSelectedRegion($event)"
                       [localStorageKeyPrefix]="'truck-journeys'"
                       [title]="'truck-journeys.list.page-title'"
                       [selectCarrierPlaceholder]="'overdue-process.page-heading-carriers-placeholder'"
                       (onCarrierFetchError)="handleHeaderCarrierFetchErrors($event)"
                       (onRegionFetchError)="handleHeaderRegionFetchErrors($event)"
                       [clearable]="isGlobalUser"
                       [lightData]="true">
    <app-carrier-sync [carrierId]="selectedCarrier?.id"></app-carrier-sync>
</app-auto-page-heading>

<app-truck-journey-list #truckJourneyList [selectedCarrier]="selectedCarrier">
</app-truck-journey-list>

<ng-template #selectCarrierTemplate>
    <span [i18n]="'truck-journeys.please-select-carrier'"></span>
</ng-template>
